import React from 'react'
import {
  StyledDeItems,
  StyledDeCategory,
  StyledDeTitles,
  StyleBox,
  StyledDeTimes,
  StyledDeLabels,
  StyledDeSummarys,
  StyledrNumber,
} from '../styled/details'
import RenderIf from '../../render-if'

const Detail = ({
  category,
  title,
  datetime,
  regulationNumber,
  label,
  content,
}) => {
  return (
    <>
      <StyledDeItems>
        <RenderIf isTrue={title}>
          <StyledDeTitles>{title}</StyledDeTitles>
        </RenderIf>
        <StyleBox>
          <RenderIf isTrue={category}>
            <StyledDeCategory>{category}</StyledDeCategory>
          </RenderIf>
          <RenderIf isTrue={datetime}>
            <StyledDeTimes>{datetime}</StyledDeTimes>
          </RenderIf>
        </StyleBox>

        <RenderIf isTrue={regulationNumber}>
          <StyleBox>
            <StyledrNumber>{regulationNumber}</StyledrNumber>
          </StyleBox>
        </RenderIf>
        <RenderIf isTrue={label}>
          <StyledDeLabels>
            #
            {Array.isArray(label)
              ? label.map((i, index) => {
                  return <span key={index}>&nbsp;&nbsp;{i}&nbsp;&nbsp;</span>
                })
              : label}
            #
          </StyledDeLabels>
        </RenderIf>
        <RenderIf isTrue={content}>
          <StyledDeSummarys>{content}</StyledDeSummarys>
        </RenderIf>
      </StyledDeItems>
    </>
  )
}

export default Detail
